export default "__VITE_ASSET__BunOFRiF__"